import { getApiUrl, AXIOS_AUTHED } from './shared';

const getRouteApprovalTier = (branchId, routeNumber) => {
  return AXIOS_AUTHED.get(`${getApiUrl()}/route-approvers/me/${branchId}:${routeNumber}`);
};

export { getRouteApprovalTier };
